// utils/dateFormatter.js
export const formatDate = (date, locale = navigator.language) => {
    return new Intl.DateTimeFormat(locale, { dateStyle: "short" }).format(new Date(date));
};

export const formatDateTime = (date, locale = navigator.language) => {
    return new Intl.DateTimeFormat(locale, {
        dateStyle: "short",
        timeStyle: "medium",
    }).format(new Date(date));
};

// 秒なしの日時フォーマット（HH:mm）
export const formatDateTimeNoSeconds = (date, locale = navigator.language) => {
    return new Intl.DateTimeFormat(locale, {
        dateStyle: "short",
        timeStyle: "short",
    }).format(new Date(date));
};
